module.exports = __webpack_public_path__ + "img/tips.eaea262.png";